module.exports = "/_next/static/images/1294c8c8644d26354c2bd31e40ba55db-card-wait-notice.svg.webp";